import { render, staticRenderFns } from "./mySeal.vue?vue&type=template&id=037d5b42&scoped=true"
import script from "./mySeal.vue?vue&type=script&lang=js"
export * from "./mySeal.vue?vue&type=script&lang=js"
import style0 from "./mySeal.vue?vue&type=style&index=0&id=037d5b42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d5b42",
  null
  
)

export default component.exports